import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined';

import { amber, blue, green, red, grey } from '@material-ui/core/colors';

import ProvaService from '../../services/Prova';
import EnumService from '../../services/Enum';
import { errors } from '../../services/API';

import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Title from '../../components/Title/Title';
import Table from '../../components/Table/Table';
import Toast from '../../components/Toast/Toast';
import {
    verifyPagingAndSorting,
    PAGE,
    DESC,
    TOTAL_ELEMENTS,
    TOTAL_PAGES,
} from '../../components/Table/Utils';

import { patternEnum } from '../../variables/Enums/Enum';

import ProvaInvalidaFilter from '../../forms/Prova/ProvaInvalidaFilter';
import DialogTratarInvalida from '../../components/Prova/DialogTratarInvalida';

import { verifyPersistence, removePagingAndSorting } from '../../helper/PaginationHelper';

import { isAdministradorOuCentral } from '../../security/AuthorizedFunction';

import { Layout } from '../../layouts/private/Private';

const STATUS_PENDENTES = ['AGUARDANDO', 'EM_TRATAMENTO'];

const CORES_STATUS_TRATAMENTO = {
    AGUARDANDO: amber[700],
    EM_TRATAMENTO: blue[600],
    RESOLVIDA: green[700],
    DESCARTADA: red[600],
};

const SIZE_PADRAO = 20;

export class ProvaInvalida extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: PAGE,
            size: SIZE_PADRAO,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
            sort: [{ orderBy: 'dataHora', order: DESC }],
            defaultOrderBy: 'dataHora',
            filtered: false,
            filters: [],
            invalidas: [],
            loading: true,
            optionsMotivo: [],
            optionsStatusTratamento: [],
            optionsMomento: [],
            dialogTratar: { open: false, idProva: null },
        }

        this.state = verifyPersistence(this.state, this.props.location);
    }

    setToast = t => this.Toast = t;
    setProvaInvalidaFilter = f => this.ProvaInvalidaFilter = f;

    handleTratar = id => this.setState({ ...this.state, dialogTratar: { open: true, idProva: id } });

    handleCloseDialogTratar = () => this.setState({ ...this.state, dialogTratar: { open: false, idProva: null } });

    codigoDaProva = id => {
        const prova = this.state.invalidas.find(p => p.id === id);

        return prova ? prova.codigo : null;
    }

    mensagemTratamento = dto => {
        if (!dto) return 'Tratamento registrado com sucesso.';

        if (dto.statusTratamento === 'RESOLVIDA') {
            const divergencia = dto.divergenciaNota
                ? ' A divergência foi detectada — a prova foi enviada para a fila de revisão.'
                : '';

            return `Prova resolvida. Nota calculada: ${dto.notaCalculadaNova ?? '-'}.${divergencia}`;
        }

        if (dto.statusTratamento === 'DESCARTADA') {
            return 'Prova descartada. Ela não retornará a nenhum fluxo.';
        }

        return 'Prova assumida para tratamento.';
    }

    handleTratada = dto => {
        this.handleCloseDialogTratar();

        this.Toast.setState({
            message: {
                message: this.mensagemTratamento(dto),
                type: 'success',
                open: true
            }
        });

        this.loadData();
    }

    emStatusPendente = id => {
        const prova = this.state.invalidas.find(p => p.id === id);

        return Boolean(prova) && STATUS_PENDENTES.includes(prova.statusTratamento);
    }

    loadData = async () => {
        let filters = verifyPagingAndSorting(this.state);

        this.setState({
            filters: [...filters],
            filtered: true,
            loading: true
        });

        await ProvaService.invalidas(filters)
            .then(res => {
                if (res.data.content) {
                    this.setState({
                        ...this.state,
                        invalidas: [...res.data.content],
                        page: res.data.number,
                        size: res.data.size,
                        totalElements: res.data.totalElements,
                        totalPages: res.data.totalPages,
                        loading: false,
                    });

                    this.ProvaInvalidaFilter.handleFilterPersistence(filters);
                } else {
                    this.setState({
                        ...this.state,
                        invalidas: [],
                        page: PAGE,
                        size: SIZE_PADRAO,
                        totalElements: TOTAL_ELEMENTS,
                        totalPages: TOTAL_PAGES,
                        loading: false,
                    });
                }
            })
            .catch(error => {
                const e = errors(error);

                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                });

                this.setState({ loading: false });
            })
    }

    filterData = (filters, isActive = true) => this.setState({ filtered: isActive, filters: [...removePagingAndSorting(filters)] }, () => this.loadData());
    handlePage = page => this.setState({ page: page }, () => this.filterData(this.state.filters));
    handleRowsPerPage = (size, page) => this.setState({ size: size, page: page }, () => this.filterData(this.state.filters));
    handleSort = (orderBy, order) => {
        if (this.state.sort.find(s => s.orderBy === orderBy)) {
            let newSort = this.state.sort.filter(s => s.orderBy !== orderBy);
            newSort.splice(this.state.sort.indexOf(this.state.sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
            this.setState({ ...this.state, sort: [...newSort], filtered: true });
        } else {
            this.setState({ ...this.state, sort: [...this.state.sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }], filtered: true });
        }
    }
    handleClearSort = (orderBy) => {
        this.setState({ ...this.state, filtered: true, sort: orderBy ? [...this.state.sort.filter(s => s.orderBy !== orderBy)] : [{ orderBy: this.state.defaultOrderBy, order: DESC }] });
    };
    handleTotalPages = () => this.state.totalPages;
    handleTotalElements = () => this.state.totalElements;
    handleFilterPersistence = () => this.ProvaInvalidaFilter ? this.ProvaInvalidaFilter.handleFilterPersistence(this.state.filters) : null;

    async componentDidMount() {
        const optionsMotivo = await EnumService.listarMotivosInvalidacao().then(res => res.data).catch(() => []);
        const optionsStatusTratamento = await EnumService.listarStatusTratamentoInvalidacao().then(res => res.data).catch(() => []);
        const optionsMomento = await EnumService.listarMomentosDigitacao().then(res => res.data).catch(() => []);

        this.setState({
            optionsMotivo: [...optionsMotivo],
            optionsStatusTratamento: [...optionsStatusTratamento],
            optionsMomento: [...optionsMomento],
        });

        this.loadData();
    }

    carregarStatusTratamento = id => {
        const prova = this.state.invalidas.find(p => p.id === id);
        const cor = CORES_STATUS_TRATAMENTO[prova.statusTratamento] ?? grey[500];

        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div>
                    <Chip
                        size="small"
                        label={patternEnum(prova.statusTratamento, this.state.optionsStatusTratamento)}
                        style={{ backgroundColor: cor, fontWeight: 600, color: 'white' }}
                    />
                </div>

                {prova.observacao &&
                    <span style={{ fontSize: 12, color: grey[700], marginTop: 4 }}>{prova.observacao}</span>
                }
            </div>
        )
    }

    labelTratar = () => 'Tratar';

    render() {
        const pageName = 'Tratamento de Provas Inválidas';
        const links = [
            {
                path: null,
                name: 'Logística Reversa'
            }
        ];

        const columns = [
            { label: '#', name: 'id', func: null, key: true, hidden: true },
            { label: 'Código de Prova', name: 'codigo', func: null, key: false, ordering: false },
            { label: 'Nome', name: 'nome', func: null, key: false, ordering: false },
            { label: 'Região', name: 'regiao', func: null, key: false, ordering: false },
            { label: 'Motivo', name: 'motivo', func: (value) => patternEnum(value, this.state.optionsMotivo), key: false, ordering: false },
            { label: 'Momento', name: 'momentoDigitacao', func: (value) => patternEnum(value, this.state.optionsMomento), key: false, ordering: false },
            { label: 'Data da Invalidação', name: 'dataHoraInvalidacao', filter: 'dataHora', func: null, key: false, ordering: true },
            { label: 'Status do Tratamento', name: 'statusTratamento', func: (value, id) => this.carregarStatusTratamento(id), key: false, ordering: false },
        ];

        const actions = [
            {
                name: this.labelTratar,
                func: this.handleTratar,
                icon: <BuildOutlinedIcon />,
                disabled: (id) => !isAdministradorOuCentral() || !this.emStatusPendente(id),
            },
        ];

        this.handleFilterPersistence();

        return (
            <Layout>
                <Toast parentRef={this.setToast} />

                <Grid container>
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={pageName} />
                    </Grid>
                </Grid>

                <Title>{pageName}</Title>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ProvaInvalidaFilter
                            parentRef={this.setProvaInvalidaFilter}
                            handleFilterChange={this.filterData}
                        />

                        <Table
                            columns={columns}
                            tableData={this.state.invalidas}
                            actions={actions}
                            groupActions={false}
                            page={this.state.page}
                            handlePage={this.handlePage}
                            handleTotalPages={this.handleTotalPages}
                            handleTotalElements={this.handleTotalElements}
                            rowsPerPage={this.state.size}
                            handleRowsPerPage={this.handleRowsPerPage}
                            sort={this.state.sort}
                            handleSort={this.handleSort}
                            handleClearSort={this.handleClearSort}
                            loading={this.state.loading}
                        />
                    </Grid>
                </Grid>

                <DialogTratarInvalida
                    open={this.state.dialogTratar.open}
                    idProva={this.state.dialogTratar.idProva}
                    codigo={this.codigoDaProva(this.state.dialogTratar.idProva)}
                    onClose={this.handleCloseDialogTratar}
                    onTratada={this.handleTratada}
                />
            </Layout>
        )
    }
}

export default withRouter(ProvaInvalida);
